import React, { PropTypes } from 'react';

import QuoteCard from './QuoteCard';
import SummaryPanel from './SummaryPanel';
import Delivery from './Delivery';
import Lease from './Lease';
import { VehicleDetails } from '../../../../components/vehicle';
import Header from '../../../../components/layouts/Header';

import { IncludedExtras, ColourAndExtras } from '../accordions';

import QuestionList from '../Question/QuestionList';

import QuoteActions from '../../create/components/QuoteActions';

import ApprovalActions from '../../workflow/components/ApprovalActions';

import { getFilteredQuestionAnswer, formatCurrency } from '../../helper.js';

import { NitroHeading, NitroLoading, NitroDivider } from 'nitro-components';
import { ColumnContainer, ColumnLarge, ColumnSmall } from '../../../../components/layouts/Columns';

const SummaryPage = props => {
  const {
    selectedVehicle,
    includedExtras,
    optionalExtras,
    selectedColour,
    leaseDetails,
    deliveryDetails,
    cost,
    leaseTerms,
    quoteId,
    isExporting,
    isSubmitting,
    editable,
    questionList,
    registrationState,
    workflowSummary,
    totalApprovers,
    currentApprover
  } = props;

  if (props.fetchingSummary) return <NitroLoading screen />;

  const decisionActions = props.decisionActions || {};

  const editActionsLocal = props.editActions || {};

  const { handleOptionsEdit, handleLeaseEdit, handleDeliveryEdit, toggleConfirm } = editActionsLocal;

  let quoteActions = props.quoteActions || {};
  const { exportAction, submitAction } = quoteActions;
  const { approveAction, declineAction, canApprove, canReject } = decisionActions;

  return (
    <section>

      <Header margin="32px 0" lineHeight={32}>
        <NitroHeading label="Quote summary" align="center" size="1" />
      </Header>

      <ColumnContainer>
        <ColumnSmall>
          <QuoteCard reference={quoteId} cost={formatCurrency(cost)} term={leaseTerms} />
          {editable
            ? <QuoteActions
                exportAction={exportAction}
                isExporting={isExporting}
                submitAction={submitAction}
                isSubmitting={isSubmitting}
              />
            : <ApprovalActions
                approveAction={approveAction}
                declineAction={declineAction}
                canApprove={canApprove}
                canReject={canReject}
                workflowSummary={workflowSummary}
                totalApprovers={totalApprovers}
                currentApprover={currentApprover}
              />}
        </ColumnSmall>

        <ColumnLarge>

          <SummaryPanel title="Vehicle" step="1" action={toggleConfirm} actionLabel="Change">

            <VehicleDetails {...selectedVehicle} horizontal showStats />
            <NitroDivider />
            <IncludedExtras options={includedExtras} />
            <NitroDivider />
            <ColourAndExtras
              action={handleOptionsEdit}
              selectedColour={selectedColour}
              selectedExtras={optionalExtras}
            />
          </SummaryPanel>

          <SummaryPanel title="Lease" step="2" action={handleLeaseEdit} actionLabel="Edit">
            <Lease leaseDetails={leaseDetails} registrationState={registrationState} />

          </SummaryPanel>

          <SummaryPanel title="Delivery" step="3" action={handleDeliveryEdit} actionLabel="Edit">
            <Delivery {...deliveryDetails} />
          </SummaryPanel>

          <SummaryPanel title="Questions">
            <QuestionList list={getFilteredQuestionAnswer(questionList)} />
          </SummaryPanel>
        </ColumnLarge>
      </ColumnContainer>
    </section>
  );
};

SummaryPage.propTypes = {
  fetchingSummary: PropTypes.bool,
  // summary card
  quoteId: PropTypes.string,
  cost: PropTypes.number,
  leaseTerms: PropTypes.string,
  // full summary can be parsed by vehicle details panel
  selectedVehicle: PropTypes.object,
  selectedColour: PropTypes.object,
  // for listing included and optional extras
  includedExtras: PropTypes.array,
  optionalExtras: PropTypes.array,
  // array of lese details
  leaseDetails: PropTypes.array,
  // obj for the delivery details panel
  deliveryDetails: PropTypes.object,
  // bools for loading / disabled states on buttons
  isExporting: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  quoteActions: PropTypes.object,
  editable: PropTypes.bool,
  editActions: PropTypes.object,
  decisionActions: PropTypes.object,
  questionList: PropTypes.array,
  registrationState: PropTypes.string,
  workflowSummary: PropTypes.array,
  totalApprovers: PropTypes.number,
  currentApprover: PropTypes.number
};

export default SummaryPage;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/components/summary/SummaryPage.js